import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

const actions = crud('travel', 'el viaje', 'los viajes')

const getClients = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_clients`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getUnits = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_units`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getDrivers = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_drivers`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getTrailers = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_trailers`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getCompanies = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_companies`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getMerchandise = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_merchandise`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getBranches = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_branches`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getTravelRoutes = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_travel_routes`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const createTravel = (data, files = [], { onSuccess } = {}) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi('/travel/create_travel', {
				method: 'POST',
				json: false,
				headers: {
					Authorization: state.app.user.token,
				},
				body: {
					item: JSON.stringify(data),
					files: files
				}
			});

			Swal.fire({
				title: t('¡Acción Realizada!'),
				text: t('Se agregó el viaje correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) onSuccess?.(res.body);
			});

			return { ok: true, data: res.body };
		} catch (error) {
			return { ok: false, error: error?.message.error || 'Error' };
		}
	};
};

const getTravel = (id) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_travel/${id}`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return {}
		}
	}
}

const updateTravel = (id, data, files = [], { onSuccess } = {}) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi(`/travel/update_travel/${id}`, {
				method: 'PUT',
				json: false,
				headers: {
					Authorization: state.app.user.token,
				},
				body: {
					item: JSON.stringify(data),
					files: files
				}
			});

			Swal.fire({
				title: t('¡Acción realizada!'),
				text: t('Se actualizó el viaje correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) onSuccess?.(res.body);
			});

			return { ok: true, data: res.body };
		} catch (error) {
			Swal.fire('Error', error?.message.error || t('No se pudo actualizar'), 'error', {showCloseButton: true,});
			return { ok: false, error: error?.message.error || 'Error' };
		}
	};
};

const deleteTravel = (id, { onSuccess } = {}) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi(`/travel/delete_travel/${id}`, {
				method: 'DELETE',
				headers: {
					Authorization: state.app.user.token,
					'Content-Type': 'application/json',
				},
			});

			Swal.fire({
				title: t('¡Acción realizada!'),
				text: t('Se eliminó el viaje correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) {
					if (onSuccess) {
						onSuccess(res.body);
					} else {
						window.location.reload();
					}
				}
			});

			return { ok: true, data: res.body };
		} catch (error) {
			Swal.fire('Error', error?.message || t('No se pudo eliminar'), 'error', {showCloseButton: true,});
			return { ok: false, error: error?.message || 'Error' };
		}
	};
};

const getAllTravels = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_all_travels`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getNextTravelFolio = (id) => {
	return async (dispatch, getState) => {
		const state = getState()


		const res = await callApi(`/travel/utils/next_travel_folio`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body

	}
}

const getSysModuleUserPermisitions = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_sys_module_user_permisitions`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getTravelData = (filters = {}) => {
	return async (dispatch, getState) => {
		const state = getState()
		const queryParams = new URLSearchParams()

		if (filters.branch_id) {
			queryParams.append('branch_id', filters.branch_id)
		} else {
			if (filters.branch_name)
				queryParams.append('branch_name', filters.branch_name)
		}

		if (filters.status) queryParams.append('status', filters.status)
		if (filters.travel) queryParams.append('travel', filters.travel)
		if (filters.travel_type)
			queryParams.append('travel_type', filters.travel_type)
		if (filters.classification)
			queryParams.append('classification', filters.classification)
		if (filters.createdBy) queryParams.append('createdBy', filters.createdBy)
		if (filters.client_id) queryParams.append('client_id', filters.client_id)
		if (filters.dateFrom) queryParams.append('dateFrom', filters.dateFrom)
		if (filters.dateTo) queryParams.append('dateTo', filters.dateTo)

		const res = await callApi(
			`/travel/utils/get_travel_data?${queryParams.toString()}`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)

		return res.body
	}
}

const getSuppliers = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_suppliers`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const getBillingConcepts = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_billing_concepts`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const createTravelExit = (data) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi('/travel/create_travel_exit', {
				method: 'POST',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify(data),
			});

			Swal.fire({
				title: t('¡Acción Realizada!'),
				text: t('Se le dio salida al viaje correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then(() => {
				window.location.reload();
			});

			return { ok: true, data: res.body };
		} catch (error) {
			return { ok: false, error: error?.message.error || 'Error' };
		}
	};
};

const getTravelExits = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/travel/utils/get_travel_exits`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			return res.body
		} catch (error) {
			return []
		}
	}
}

const deleteTravelExit = (id) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi(`/travel/delete_travel_exit/${id}`, {
				method: 'DELETE',
				headers: {
					Authorization: state.app.user.token,
					'Content-Type': 'application/json',
				},
			});

			Swal.fire({
				title: t('¡Acción realizada!'),
				text: t('Se eliminó la salida de viaje correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.reload();
				}
			});

			return { ok: true, data: res.body };
		} catch (error) {
			Swal.fire('Error', error?.message || t('No se pudo eliminar'), 'error', {showCloseButton: true,});
			return { ok: false, error: error?.message || 'Error' };
		}
	};
};

const updateTravelExit = (id, data) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi(`/travel/update_travel_exit/${id}`, {
				method: 'PUT',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify(data)
			});

			Swal.fire({
				title: t('¡Acción realizada!'),
				text: t('Se actualizó la salida de viaje correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			}).then((result) => {
				window.location.reload();
			});

			return { ok: true, data: res.body };
		} catch (error) {
			Swal.fire('Error', error?.message.error || t('No se pudo actualizar'), 'error', {showCloseButton: true,});
			return { ok: false, error: error?.message.error || 'Error' };
		}
	};
};

const sendTravelEmail = (data) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {

			const res = await callApi('/travel/send_travel_email', {
				method: 'POST',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify(data),


			});
			Swal.fire({
				title: t('¡Correo Enviado!'),
				text: t('El correo se ha enviado correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			});

			return { ok: true, data: res.body };
		} catch (error) {
			Swal.fire({
				title: t('¡Error!'),
				text: error?.message?.error || t('Ocurrió un error al enviar el correo'),
				icon: 'error',
				showCloseButton: true,
			});

			return { ok: false, error: error?.message?.error || 'Error' };
		}
	};
};


const importCargoMaterials = (travelId, materials) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {
			const res = await callApi(`/travel/${travelId}/cargo/import`, {
				method: 'POST',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify({ materials })
			});
			return res.body;
		} catch (error) {
			console.error(error);
			return { success: false, message: error?.message || 'Error' };
		}
	};
};

const sendMassiveTravelEmail = (data) => {
	return async (dispatch, getState) => {
		const state = getState();
		try {

			const res = await callApi('/travel/send_massive_travel_email', {
				method: 'POST',
				headers: {
					Authorization: state.app.user.token,
				},
				body: JSON.stringify(data),


			});
			Swal.fire({
				title: t('¡Correos Enviados!'),
				text: t('Los correos se han enviado correctamente.'),
				icon: 'success',
				confirmButtonText: t('OK'),
				showCloseButton: true,
			});

			return { ok: true, data: res.body };
		} catch (error) {
			Swal.fire({
				title: t('¡Error!'),
				text: error?.message?.error || t('Ocurrió un error al enviar el correo'),
				icon: 'error',
				showCloseButton: true,
			});

			return { ok: false, error: error?.message?.error || 'Error' };
		}
	};
};

export default {
	...actions,
	getClients,
	getUnits,
	getDrivers,
	getTrailers,
	getCompanies,
	getMerchandise,
	getBranches,
	getTravelRoutes,
	createTravel,
	getTravel,
	updateTravel,
	deleteTravel,
	getAllTravels,
	getNextTravelFolio,
	getSysModuleUserPermisitions,
	getTravelData,
	getSuppliers,
	getBillingConcepts,
	createTravelExit,
	getTravelExits,
	deleteTravelExit,
	updateTravelExit,
	importCargoMaterials,
	sendTravelEmail,
	sendMassiveTravelEmail,
}
